export default "__VITE_ASSET__MkosO4Ks__"